import { IInspectionsHook } from '@models';
import { useStore } from '@stores';
import { useCallback, useEffect } from 'react';

interface IProps {
  orderId?: string;
  vrm?: string;
  customerId?: string;
}

export const useInspections = ({ orderId, vrm, customerId }: IProps): IInspectionsHook => {
  const { inspectionStore } = useStore();
  const {
    inspections,
    loading,
    maxResultCount,
    skipCount,
    totalCount,
    currentPage,
    handlePageChange,
  } = inspectionStore;

  useEffect(() => {
    return () => inspectionStore.resetInspections();
  }, [inspectionStore]);

  /**
   * Also exposed to the caller: the rows carry how far along each checklist is, and that goes stale
   * the moment one is edited. Left to the mount effect alone, someone could fill in a checklist,
   * close it, and be looking at the count it had before they started.
   */
  const refresh = useCallback(() => {
    if (!orderId && !vrm && !customerId) return;

    inspectionStore.getAll({
      orderId,
      vrm,
      customerId,
      skipCount,
      maxResultCount,
    });
  }, [inspectionStore, orderId, vrm, customerId, skipCount, maxResultCount]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    loading,
    totalCount,
    currentPage,
    maxResultCount,
    dataSource: Array.from(inspections.values()),
    handlePageChange,
    refresh,
  };
};
